<template>
  <div class="buttons" :class="position">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'

const props = defineProps<{
  position?: 'left' | 'center' | 'right'
}>()
</script>

<style scoped>
.buttons {
  display: flex;
  flex-wrap: wrap;  
  gap: 5px;
}
.buttons.left {
  justify-content: flex-start;
}
.buttons.center {
  justify-content: center;
}
.buttons.right {
  justify-content: flex-end;
}
</style>
